import FinanceApi from '@/services/FinanceApi';

const getAll = async (config) => {
    return FinanceApi.get('/customer/budget/payments', config);
}
const get = async (id) => {
    return FinanceApi.get('/customer/budget/payments/' + id);
}
const store = async (data) => {
    return FinanceApi.post('/customer/budget/payments', data);
}
const update = async (id, formData) => {
    return FinanceApi.put('/customer/budget/payments/' + id, formData);
}
const del = async (id) => {
    return FinanceApi.delete('/customer/budget/payments/' + id);
}
const exportExcel = async (config) => {
    return FinanceApi.get('/customer/budget/payments/excel-export',config);
}

export default {
    getAll,
    update,
    get,
    store,
    del,
    exportExcel
}
